import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { ADVICE_PRICE_STEP } from "../../adviceSteps";
import { AdvicePriceFormValues } from "../AdviceCards/interfaces";
import { useAdvicePriceCalculationRequests } from "./stateSelectors";

export const useAdvicePriceFormValues = (): {
  disabilityInsuredSum: number;
  disabilityOneTimePayment?: number;
  deathInsuredSum: number;
  criticalIllnessInsuredSum: number;
  adviceComment?: string;
} => {
  const {
    priceCalculation: { priceCalculationFormStates },
  } = useSelector((state: ReduxState) => state);
  const advicePriceCalculationRequests = useAdvicePriceCalculationRequests();

  const getInsuredSum = (insuranceName: INSURANCE_NAME_VALUE): number => {
    return (
      advicePriceCalculationRequests.changedByCustomer[insuranceName]
        ?.priceCalculationRequest?.data?.insuredSum ??
      advicePriceCalculationRequests.initialRequest[insuranceName]
        ?.priceCalculationRequest?.data?.insuredSum
    );
  };

  return {
    disabilityInsuredSum: getInsuredSum(INSURANCE_NAME_VALUE.DISABILITY_FLEX),
    disabilityOneTimePayment:
      advicePriceCalculationRequests.changedByCustomer[
        INSURANCE_NAME_VALUE.DISABILITY_FLEX
      ]?.priceCalculationRequest?.data?.coverageAmountCapital ??
      advicePriceCalculationRequests.initialRequest[
        INSURANCE_NAME_VALUE.DISABILITY_FLEX
      ]?.priceCalculationRequest?.data?.coverageAmountCapital,
    deathInsuredSum: getInsuredSum(INSURANCE_NAME_VALUE.DEATH),
    criticalIllnessInsuredSum: getInsuredSum(
      INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
    ),
    adviceComment: (
      priceCalculationFormStates[ADVICE_PRICE_STEP.id] as AdvicePriceFormValues
    )?.adviceComment,
  };
};
